<template>
	<div>
		<loading v-if="loading"></loading>
		<v-app v-else light>
			<template>
				<event-rsvp-success-modal></event-rsvp-success-modal>
				<generic-modal></generic-modal>
				<terms-modal></terms-modal>
				<contact-form></contact-form>
				<payment-modal></payment-modal>
				<membership-upsell-modal></membership-upsell-modal>
				<edit-event-contact-form></edit-event-contact-form>
				<auth-modal></auth-modal>
				<host-help-modal></host-help-modal>
				<nav-toolbar v-if="shouldShowNavbar"></nav-toolbar>
				<mobile-nav-footer v-if="shouldShowMobileNav"></mobile-nav-footer>
				<share-modal></share-modal>
				<add-to-calendar-modal></add-to-calendar-modal>
				<about-us-modal></about-us-modal>
				<event-host-modal></event-host-modal>
				<event-attendees-modal></event-attendees-modal>
				<event-location-modal></event-location-modal>
				<event-guest-requirements-modal></event-guest-requirements-modal>
				<event-contact-host-modal></event-contact-host-modal>
				<event-contact-guest-modal></event-contact-guest-modal>
				<event-contact-all-guests-modal></event-contact-all-guests-modal>
				<event-guest-modal></event-guest-modal>
				<event-cohost-modal></event-cohost-modal>
				<event-report-event-modal></event-report-event-modal>
				<event-cancellation-policy-modal></event-cancellation-policy-modal>
				<why-linkedin-modal></why-linkedin-modal>
				<host-process-modal></host-process-modal>
				<deny-guest-confirmation-modal></deny-guest-confirmation-modal>
				<registration-confirmation-modal></registration-confirmation-modal>
				<!-- <active-event-chat-modal></active-event-chat-modal>
				<active-event-timer-modal></active-event-timer-modal> -->
				<purchase-addon-modal></purchase-addon-modal>
				<purchase-addon-success-modal></purchase-addon-success-modal>
				<addon-upsell-modal></addon-upsell-modal>
				<permissions-prompt-modal></permissions-prompt-modal>
				<v-content class="pa-0 app-content">
					<v-snackbar
						:timeout="6000"
						bottom
						left
						v-model="snackbarOpen"
						color="primary"
					>
						{{ getSnackbarText }}
						<v-btn flat color="white" @click="snackbarOpen = false">Close</v-btn>
					</v-snackbar>
					<router-view style="min-height: 100vh;"></router-view>
					<div app v-if="shouldShowFooter && getShowFooter" class="hidden-xs-only app-footer" :style="getFooterStyle">
						<div style="display: flex; flex-direction: row; justify-content: space-between">
							<div class="pt-5 pl-5 pb-5 pr-2" style="max-width: 900px;">
								<div class="text-xs-left">
								<!--	<p class="quantico">Created, built, and motivated by rad humans who<br> just want to <strong>wrkprty</strong> everywhere (and Venice Beach, California).</p>-->
									<p class="quantico" style="color: #bbb7b7">
										<!-- <a @click="openAboutUs">Our Story</a>-->
										<!-- &nbsp;&nbsp;|&nbsp;&nbsp; -->
										<!-- <router-link :to="{ name: 'team' }">Team</router-link>&nbsp;&nbsp;|&nbsp;&nbsp; -->
										<!--Help us grow this movement! </p>-->
										<p class="quantico" style="color: #bbb7b7">Follow &amp; connect with us <a class="success--text" href="https://instagram.com/wrkprty" target="_blank" @click="clickLink('instagram')">@wrkprty</a> or <a class="success--text" href="https://twitter.com/wrkprty" target="_blank" @click="clickLink('twitter')">#wrkprty</a>
									</p>
								<!-- 	<p class="quantico" style="font-size: 0.9em; color: #bbb7b7">
										WRKPRTY&reg;  WORKPARTY&reg; and associated logos are registered trademarks of wrkprty Inc.<br>
										All site content &copy; 2016-{{ year }} wrkprty Inc. All rights reserved.
									</p> -->
								</div>
							</div>
							<div style="display: flex; flex-direction: row; justify-content: flex-end;">
								<div class="pa-3 pt-5">
									<div class="text-xs-right pa-4 pt-3 pb-3" style="width: 100%; border-right: 2px solid #d9d9d9">
										<p class="pa-2 quantico">
											<a style="cursor: pointer" @click="setModalOpen({prop:'contactForm', value: true})">Contact Us</a><br><a href="https://angel.co/wrkprty" target="_blank" @click="clickLink('careers')">Careers</a><br><router-link :to="{ name: userIsHost ? 'host_dashboard' : 'host_info' }">Host</router-link>
										</p>
									</div>
								</div>
								<div class="pa-3 pt-5" style="max-width: 300px;">
									<a
										class="footer__social-button"
										href="https://instagram.com/wrkprty"
										target="_blank"
										@click="clickLink('instagram')"
									>
										<i class="footer__social-icons instagram fab fa-instagram"></i>
									</a>
									<a
										class="footer__social-button"
										href="https://www.linkedin.com/company/wrkprty/"
										target="_blank"
										@click="clickLink('linkedin')"
									>
										<i class="footer__social-icons linkedin fab fa-linkedin"></i>
									</a>
									<a
										class="footer__social-button"
										href="https://angel.co/wrkprty"
										target="_blank"
										@click="clickLink('angellist')"
									>
										<i class="footer__social-icons angellist fab fa-angellist"></i>
									</a>
									<a
										class="footer__social-button"
										href="https://twitter.com/wrkprty"
										target="_blank"
										@click="clickLink('twitter')"
									>
										<i class="footer__social-icons twitter fab fa-twitter"></i>
									</a>
									<a
										class="footer__social-button"
										href="https://facebook.com/wrkprty"
										target="_blank"
										@click="clickLink('facebook')"
									>
										<i class="footer__social-icons facebook fab fa-facebook-f"></i>
									</a>
								<!--	<a
										class="footer__social-button"
										href="https://plus.google.com/+wrkprty"
										target="_blank"
										@click="clickLink('googleplus')"
									>
										<i class="footer__social-icons google fab fa-google-plus-g"></i>
									</a> -->
									<a
										class="footer__social-button"
										href="https://www.pinterest.com/wrkprty/"
										target="_blank"
										@click="clickLink('pintrest')"
									>
										<i class="footer__social-icons pinterest fab fa-pinterest-p"></i>
									</a>
								</div>
							</div>
						</div>
						<div style="display: flex; flex-direction: row; justify-content: center; width: 100%;" class="pb-2">
							
							<img src="/static/images/line-logo.svg" width="200" height="25" alt="" class="mb-2">
									

							<!-- 
								<p>	WRKPRTY&reg;, WORKPARTY&reg; and logos are registered trademarks. <br>All content &copy; 2016-{{ year }} wrkprty Inc. All rights reserved.</p>
-->
						</div>
					</div>
				</v-content>
			</template>
		</v-app>
	</div>
</template>

<script>
import EventRsvpSuccessModal from './components/modals/EventRSVPSuccessModal.vue'
import AuthModal from './components/authentication/AuthenticationModal.vue'
import NavToolbar from './components/navigation/NavToolbar.vue'
import MobileNavFooter from './components/navigation/MobileNavFooter.vue'
import HostHelpModal from './components/modals/HostHelpModal.vue'
import GenericModal from './components/modals/GenericModal.vue'
import MembershipUpsellModal from './components/modals/MembershipUpsellModal.vue'
import PaymentModal from './components/modals/PaymentModal.vue'
import ContactForm from './components/modals/ContactForm.vue'
import EditEventContactForm from './components/modals/EditEventContactForm.vue'
import ShareModal from './components/modals/ShareModal.vue'
import AddToCalendarModal from './components/modals/AddToCalendarModal.vue'
import AboutUsModal from './components/modals/AboutUsModal.vue'
import EventHostModal from './components/modals/EventHostModal.vue'
import EventAttendeesModal from './components/modals/EventAttendeesModal.vue'
import EventLocationModal from './components/modals/EventLocationModal.vue'
import EventGuestRequirementsModal from './components/modals/EventGuestRequirementsModal.vue'
import EventContactHostModal from './components/modals/EventContactHostModal.vue'
import EventContactGuestModal from './components/modals/EventContactGuestModal.vue'
import EventContactAllGuestsModal from './components/modals/EventContactAllGuestsModal.vue'
import EventGuestModal from './components/modals/EventGuestModal.vue'
import EventCohostModal from './components/modals/EventCohostModal.vue'
import EventReportEventModal from './components/modals/EventReportEventModal.vue'
import EventCancellationPolicyModal from './components/modals/EventCancellationPolicyModal.vue'
import WhyLinkedinModal from './components/modals/WhyLinkedinModal.vue'
import HostProcessModal from './components/modals/HostProcessModal.vue'
import DenyGuestConfirmationModal from './components/modals/DenyGuestConfirmationModal.vue'
import RegistrationConfirmationModal from './components/modals/RegistrationConfirmationModal.vue'
// import ActiveEventChatModal from './components/modals/active_event/ChatModal.vue'
// import ActiveEventTimerModal from './components/modals/active_event/TimerModal.vue'
import PurchaseAddonModal from './components/modals/PurchaseAddonModal.vue'
import PurchaseAddonSuccessModal from './components/modals/PurchaseAddonSuccessModal.vue'
import Loading from './Loading.vue'
import AddonUpsellModal from './components/modals/AddonUpsellModal.vue'
import PermissionsPromptModal from './components/modals/PermissionsPromptModal'

import { mapActions, mapGetters } from 'vuex'
import { isEmpty, decodeUrl } from '~/store/util/util'
import axios from 'axios'
import {differenceInDays, getYear, parse, format} from 'date-fns'
import jwtDecode from 'jwt-decode'

import btDropin from 'braintree-web-drop-in'

const TermsModal = () =>
	import(/* webpackChunkName: "terms-modal" */ './components/modals/TermsModal.vue')

export default {
	name: 'root',
	data() {
		return {
			year: getYear(new Date()),
			loading: true,
			messages: [],
			currentLocation: {
				currentLocationLat: null,
				currentLocationLon: null,
				currentLocation: null
			},
			radius: 25,
			shouldShowNavbar: true,
			shouldShowFooter: true,
			shouldShowMobileNav: true
		}
	},
	created () {
		if (this.userIsAuthenticated) {
			// Check if token needs to be refreshed
			let token = this.getToken
			let tokenData = jwtDecode(token)
			let jwtExp = parse(tokenData.exp).getTime()
			if (differenceInDays(jwtExp, new Date()) < 59) {
				axios
					.post('/api-token-refresh/', { token: token })
					.then((response) => {
						this.setToken(response.data.token)
					})
					.catch((error) => {
						// Refresh failed
						console.error(error)
					})
			}
		}
	},
	mounted() {
		let hash = window.location.hash.slice(1)
		if (hash === 'login' || hash === 'register' || hash === 'resetpassword') {
			this.setAuthModalOpen(true)
		}
		window.onpopstate = event => {
			if (!this.getDontTriggerPop) {
				this.setDontTriggerPop(true)
				this.setModalOpen({ prop: this.getActiveModal, value: false })
			} else {
				this.setDontTriggerPop(false)
			}
		}
		var vars = {};
    var parts = window.location.href.replace(/[?&]+([^=&]+)=([^&]*)/gi, function(m,key,value) {
			vars[key] = value;
    });
		if (vars.hasOwnProperty('modal')) {
			if (vars['modal'] == 'termsModal') {
				this.setTermsPage('termsandconditions')
				this.setModalOpen({prop: 'termsModal', value: true})
			} else if (vars['modal'] == 'privacy') {
				this.setTermsPage('privacypolicy')
				this.setModalOpen({prop: 'termsModal', value: true})
			}
		}
		if (isEmpty(this.getVisitorLocation)) {
			this.fetchLocationByIP()
		}
		this.checkRedirect()
		if (this.userIsAuthenticated) {
			this.name = this.user.first_name + ' ' + this.user.last_name
			this.email = this.user.email
		}
		if (this.userIsAuthenticated) {
			axios
				.post('/api-token-verify/', { token: this.getToken })
				.then(response => {
					axios
						.all([
							this.fetchUserHost(),
							this.fetchWelcomeMessage()
						])
						.then(
							axios.spread(
								(
									responseUserHostVerify,
									responseWelcomeMessage,
								) => {
									if (responseUserHostVerify.data.host) {
										this.setUserHost(responseUserHostVerify.data.host)
									} else {
										this.setUserHost(null)
									}
									if (responseUserHostVerify.data.user) {
										this.setUserSocial(responseUserHostVerify.data.user)
									} else {
										console.error(
											'No user object returned from verify endpoint'
										)
									}
									if (responseWelcomeMessage.data) {
										this.setAdminProp({
											prop: 'welcomeMessage',
											value: responseWelcomeMessage.data.welcome_message
										})
									}
									this.loading = false
									this.fetchEventData()
								}
							)
						)
						.catch(error => {
							console.error(error)
						})
				})
				.catch(error => {
					console.error(error)
					console.error(error.response)
					let msg = error.response.data.non_field_errors[0]
					this.setSnackbarOpen(true)
					this.setSnackbarText(msg)
					this.logout()
				})
		} else {
			this.loading = false
		}
	},
	methods: {
		...mapActions([
			'setModalProp',
			'subscribeUserToPush',
			'setDontTriggerPop',
			'fetchWelcomeMessage',
			'setAdminProp',
			'setModalOpen',
			'setTermsPage',
			'setAuthModalOpen',
			'setAuthRedirect',
			'setUserSocial',
			'setToken',
			'setUserHost',
			'setAllLocations',
			'logout',
			'setSnackbarOpen',
			'setSnackbarText',
			'fetchLocationByIP',
			'setNotifications',
		]),
		fetchEventData() {
			this.fetchNotifications()
				.then((response) => {
					this.setNotifications(response.data)
				})
			axios.get('/api/v1/location/?format=json')
				.then((response) => {
					this.setAllLocations(response.data)
				})
				.catch((error) => {
					console.error(error)
				})
		},

		checkRoute(path, name) {
			let showNavbar = true
			let showFooter = true
			let showMobileNav = true
			if (name === 'social_login') {
				showNavbar = false
				showFooter = false
				showMobileNav = false
			} else if (name === 'user_confirmation') {
				showNavbar = false
				showFooter = false
				showMobileNav = false
			} else if (
				name === 'host_apply' ||
				name === 'host_space' ||
				name === 'host_apply_success'
			) {
				showNavbar = false
				showFooter = false
				showMobileNav = false
			} else if (path.indexOf('/host/add/') > -1) {
				showNavbar = false
				showFooter = false
				showMobileNav = false
			} else if (name === 'event') {
				showNavbar = false
				showFooter = true
				showMobileNav = false
			} else if (name === 'location') {
				showNavbar = false
				showFooter = true
				showMobileNav = false
			} else if (name === 'root' && !this.userIsAuthenticated) {
				showMobileNav = false
			} 
			// else if (name === 'active_event') {
			// 	showFooter = false
			// 	showMobileNav = false
			// 	showNavbar = false
			// }

			if (path.indexOf('/host/') > -1 && name !== 'host_dashboard') {
				showFooter = false
				showMobileNav = false
			}
			this.shouldShowNavbar = showNavbar
			this.shouldShowFooter = showFooter
			this.shouldShowMobileNav = showMobileNav
		},
		routeTo(url) {
			this.rightDrawer = false
			this.$router.push(url)
		},
		fetchUserHost() {
			return axios.get('/api/v1/user-verification/')
		},
		fetchNotifications() {
			return axios.get('/api/v1/notifications/')
		},
		checkRedirect(to = null, from = null) {
			let path = null
			let name = null
			if (to && from) {
				path = to.path
				name = to.name
				this.checkRoute(path, name)
			} else {
				path = window.location.pathname
				name = this.$route.name
				this.checkRoute(path, name)
			}
			let params = window.location.search.slice(1).split(/[\?\&]+/)
			for (let param in params) {
				let prop = params[param].split('=')[0]
				let value = params[param].split('=')[1]
				if (prop === 'redirect') {
					// this.setAuthModalOpen(true)
					// this.setSnackbarText('You must be logged in to view this page')
					this.setSnackbarOpen(true)
					this.setAuthRedirect(decodeUrl(value))
				}
				if (prop === 'notif') {
					this.setSnackbarOpen(true)
				}
			}
		},
		openAboutUs() {
			this.setModalOpen({ prop: 'aboutUsModal', value: true })
		}
	},
	watch: {
		$route(to, from) {
			this.checkRedirect(to, from)
		}
	},
	computed: {
		...mapGetters([
			'getDontTriggerPop',
			'userIsAuthenticated',
			'getSnackbarOpen',
			'getSnackbarText',
			'getToken',
			'userIsHost',
			'user',
			'getVisitorLocation',
			'getActiveModal'
		]),
		getShowFooter () {
			return true
		},
		snackbarOpen: {
			get() {
				return this.getSnackbarOpen
			},
			set(value) {
				this.setSnackbarOpen(value)
			}
		},
		getFooterStyle() {
			if (this.$route.name === 'root' && !this.userIsAuthenticated) {
				return {
					'background-color': '#0c0c0c',
					color: 'white',
					'z-index': -1
				}
			} else {
				return {
					'background-color': '#FAFAFA',
					color: '#444444',
					'z-index': -1
				}
			}
		},
		contactForm: {
			get() {
				return this.getModalProp('contactForm')
			},
			set(val) {
				this.setModalOpen({ prop: 'contactForm', value: val })
			}
		},
		transparentToolbarScrollButton() {
			let top = this.scrollPos
			if (top < 50) {
				return {
					color: 'white!important'
				}
			}
			return {
				color: '#404040!important'
			}
		},
		transparentToolbarScroll() {
			let top = this.scrollPos
			if (top < 50) {
				return {
					'background-color': 'transparent!important',
					color: 'white!important'
				}
			}
			return {
				'background-color': '#f5f5f5!important',
				color: '#404040!important'
			}
		},
		menuItems() {
			let menuItems = [
				{ title: 'Login', icon: 'fa-sign-in', link: '/login' },
				{ title: 'Register', icon: 'fa-user-plus', link: '/register' }
			]
			if (this.userIsAuthenticated) {
				menuItems = [
					{ title: 'Dashboard', icon: 'fa-home', link: '/dashboard' },
					{ title: 'Browse', icon: 'fa-calendar', link: '/event-search' }
				]
			}
			return menuItems
		},
		sideMenuItems() {
			let menuItems = []
			if (this.userIsAuthenticated) {
				menuItems = [
					{ title: 'Profile', icon: 'fa-user', link: '/profile/me' },
					{ title: 'Settings', icon: 'fa-cog', link: '/user/settings' },
					{ title: 'Logout', icon: 'fa-sign-out', link: '/user/logout' }
				]
			}
			return menuItems
		},
		dashboardMenuItems() {
			let dashboardMenuItems = []

			dashboardMenuItems = [
				{
					title: 'My Hosted Events',
					icon: 'lock_open',
					link: '/dashboard/hosted_events'
				},
				{
					title: 'My Upcoming Events',
					icon: 'vpn_key',
					link: '/dashboard/upcoming_events'
				},
				{
					title: 'Recommended Events',
					icon: 'web',
					link: '/dashboard/recommended_events'
				}
			]

			return dashboardMenuItems
		},
		user() {
			return this.$store.getters.user
		}
	},
	components: {
		PermissionsPromptModal,
		AddonUpsellModal,
		PurchaseAddonModal,
		PurchaseAddonSuccessModal,
		// ActiveEventTimerModal,
		// ActiveEventChatModal,
		RegistrationConfirmationModal,
		DenyGuestConfirmationModal,
		HostProcessModal,
		WhyLinkedinModal,
		EventContactGuestModal,
		EventContactAllGuestsModal,
		EventCancellationPolicyModal,
		EventCohostModal,
		EventReportEventModal,
		EventGuestModal,
		EventGuestRequirementsModal,
		EventHostModal,
		EventContactHostModal,
		EventAttendeesModal,
		EventLocationModal,
		AboutUsModal,
		EventRsvpSuccessModal,
		HostHelpModal,
		AuthModal,
		NavToolbar,
		MobileNavFooter,
		TermsModal,
		GenericModal,
		PaymentModal,
		MembershipUpsellModal,
		ContactForm,
		Loading,
		EditEventContactForm,
		ShareModal,
		AddToCalendarModal
	}
}
</script>

<style lang="scss">
.app-footer {
	display: block;
}
.twitter:hover {
	color: #32ccfe;
}
.angellist:hover {
	color: black;
}
.google:hover {
	color: #cf3d2e;
}
.linkedin:hover {
	color: #0085ae;
}
.instagram:hover {
	color: #a1755c;
}
.facebook:hover {
	color: #3c599f;
}
.pinterest:hover {
	color: #cc2127;
}
.footer__social-button {
	font-size: 2.6em;
	margin: 5px 6%;
	-webkit-filter: grayscale(100%);
	filter: grayscale(100%);

	&:hover {
		-webkit-filter: grayscale(0%);
		filter: grayscale(0%);
	}
}

.stop-scrolling {
	height: 100%;
	overflow: hidden;
}
</style>
